var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "-1 -1 32 33",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 16.534a6.1 6.1 0 1 0 0-12.2 6.1 6.1 0 0 0 0 12.2Zm0-10.916a4.821 4.821 0 0 1 4.816 4.816 4.821 4.821 0 0 1-4.816 4.816 4.821 4.821 0 0 1-4.815-4.816 4.821 4.821 0 0 1 4.815-4.816Z",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 0C6.841 0 0 6.841 0 15.25 0 23.659 6.841 30.5 15.25 30.5c8.409 0 15.25-6.841 15.25-15.25C30.5 6.841 23.659 0 15.25 0Zm0 1.284c7.7 0 13.966 6.265 13.966 13.966 0 3.446-1.257 6.602-3.334 9.04l-.384-1.612a6.719 6.719 0 0 0-6.558-5.18h-7.38a6.72 6.72 0 0 0-6.559 5.18l-.383 1.612a13.901 13.901 0 0 1-3.334-9.04c0-7.7 6.265-13.966 13.966-13.966ZM5.673 25.401l.578-2.426a5.44 5.44 0 0 1 5.31-4.193h7.379a5.44 5.44 0 0 1 5.31 4.193l.577 2.426a13.912 13.912 0 0 1-9.577 3.815A13.912 13.912 0 0 1 5.673 25.4Z",
    strokeWidth: 0.3
  })));
};
var Memo = /*#__PURE__*/memo(SvgProfile);
export default Memo;